import React from "react";

export default function HuntRentalIcon(props) {
  return(
      <img src="/Icons/huntRental.svg" alt="hunt rental" {...props}/>
  )
}
